<template>
  <div>
    <b-card>
      <div>
        <!-- table -->
        <vue-good-table
            styleClass="vgt-table table-custom-style striped"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-per-page-change="onPerPageChange"
          :rows="rows"
          :columns="columns"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <template v-if="props.column.field === 'format_image'">
              <b-link v-on:click="onShowPage(props.row.id)">
                <b-img
                  :src="props?.row?.asset_image"
                  class="custom-asset-image"
                ></b-img>
              </b-link>
            </template>
            <template v-if="props?.column?.field === 'format_info'">
              <h5 class="mt-1">
                <b-link :href="getPageUrl(props.row.id)" v-on:click="onShowPage(props.row.id)"
                  >{{ props?.row?.title }}
                </b-link>
              </h5>
              <div class="mt-1">
                <h6>Comp SN: <b>{{ props?.row?.company_serial_number }}</b></h6>
                <h6>
                  <b>Type: </b>
                  <b-badge variant="light-primary">{{
                    formatAssetType(props?.row?.type)
                  }}</b-badge>
                </h6>
                <h6>Category: <b>{{ props?.row?.asset_category?.name }}</b></h6>
              </div>
              <b-button
                class="btn-sm"
                variant="outline-primary"
                v-on:click="showDescriptionHistory(props.row.id)"
              >
                <feather-icon class="cursor-pointer" icon="AlertCircleIcon"
              /></b-button>
            </template>
            <!-- Column: Action -->
            <span v-if="props.column.field === 'action'">
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <template v-if="$permissionAbility(MY_ASSET_DETAILS, permissions)">
                    <b-dropdown-item v-on:click="onShowPage(props.row.id)">
                      <feather-icon icon="EyeIcon" class="mr-50" />
                      <span>Show</span>
                    </b-dropdown-item>
                  </template>
                </b-dropdown>
              </span>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['10', '25', '50', '100', '500']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>
    </b-card>
    <b-modal
        id="asset-description-log-modal"
        scrollable
        title="Description History"
        hide-footer
        no-close-on-backdrop
        size="lg"
      >
        <b-card-text class="mt-1">
          <app-timeline>
            <app-timeline-item
              v-for="(log, index) in assetAcitivityLog"
              :key="index"
              variant="primary"
            >
              <small class="text-muted">{{
                formatDateTime(log?.created_at)
              }}</small>
              <div
                class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-sm-0"
              >
                <p v-html="formatLogDescription(log)"></p>
              </div>
            </app-timeline-item>
          </app-timeline>
        </b-card-text>
      </b-modal>
  </div>

</template>

<script>
import {
  BCard,
  BAvatar,
  BImg,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BRow,
  BCol,
  BModal,
  BSpinner,
  BLink,
  BFormDatepicker,
  BFormFile,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
  BDropdownForm,
  BDropdownGroup,
  BDropdownDivider,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import { quillEditor } from "vue-quill-editor";

import { required, max, size, ext, min_value } from "@validations";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { assetTypeConstant } from "@/helpers/constant/assetTypeConstant";
import {
  ASSET_EXPORT,
  ASSET_CREATE,
  MY_ASSET_DETAILS,
  ASSET_DELETE,
} from "@/helpers/permissionsConstant";
import { FileMinusIcon } from "vue-feather-icons";
import flatPickr from 'vue-flatpickr-component'
import FormatCurrency from '@/layouts/components/FormatCurrency.vue'
extend("custom_gb_rule", {
  ...required,
  validate: (value) => {
    const pattern = /gb/i;
    return pattern.test(value) || 'Input must contain "gb" or "GB" or "Gb"';
  },
});

export default {
  name: "AssetView",
  components: {
    FormatCurrency,
    AppTimeline,
    AppTimelineItem,
    BCardText,
    BForm,
    BButton,
    BImg,
    BLink,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    flatPickr,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BFormDatepicker,
    BFormFile,
    quillEditor,
    BFormCheckboxGroup,
    BFormCheckbox,
    BDropdownForm,
    BDropdownGroup,
    BDropdownDivider,
    FileMinusIcon,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      editorOption: {
        modules: {
          toolbar: "#toolbar",
        },
      },
      customRules: {
        custom_gb_rule: (value) => {
          // Use a regular expression to check if the input contains "gb" or "GB" or "Gb"
          const pattern = /gb/i; // 'i' makes the match case-insensitive
          return (
            pattern.test(value) || 'Input must contain "gb" or "GB" or "Gb"'
          );
        },
      },

      selectedAttribute: [],
      attributeCheckboxSelected: 0,

      ASSET_EXPORT,
      ASSET_CREATE,
      MY_ASSET_DETAILS,
      ASSET_DELETE,
      // dynamic form
      loopForm: [],
      //asset Filtering
      delayTimer: null,
      searchTerm: "",
      searchAttributeValue: [],
      department_id: "",
      filter_status: "",
      filterStartDate: "",
      filterRangeDate: "",
      filterEndDate: "",
      filter_start_date: "",
      filter_end_date: "",
      selectDepartmentIdOptions: [],
      filteredStatusValueOption: [
        { name: "Available", value: "Available" },
        { name: "Assigned", value: "Assigned" },
        { name: "Damaged", value: "Damaged" },
      ],

      openAttributeCheckbox: false,
      modelType: "",
      assetAcitivityLog: [],
      assetId: "",
      asset_type_modal: "",
      asset_category_id: "",
      assetCategoryId: "",
      editAssetId: "",
      isAttributeDropdownDisabled: false,
      title: "",
      filter_asset_type: "",
      filter_asset_category_id: "",
      selectAssetTypeIdOptions: [],
      assetTypeConstant,
      editAttributeValueOptions: [],
      categoryAttributesArray: [],
      categoryAttributesEditArray: [],
      filteredAttributes: [],
      assetAttribute: [],
      isCategoryDisabled: false,
      isEditAssetCategoryIdDisabled: false,
      isEditAssetTypeDisabled: false,
      company_serial_number: "",
      manufacturer_serial_number: "",
      cost: "",
      purchase_date: "",
      asset_image: "",
      warranty_duration: "",
      warranty_type: "",
      attributeValue: [],
      editAttributeValue: [],
      asset_attribute_values: [],
      asset_attribute: [],
      file: null,
      purchaseReceipt: null,
      selectedCurrency: "",
      currencyOption: [],
      description: "",
      status: "",
      statusValueOption: [
        {
          name: "Available",
          value: "Available",
        },
        {
          name: "Damaged",
          value: "Damaged",
        },
      ],
      warrantyTypeValueOption: [
        {
          name: "Days",
          value: "Days",
        },
        {
          name: "Months",
          value: "Months",
        },
        {
          name: "Years",
          value: "Years",
        },
      ],
      columns: [
        {
          label: "Asset Image",
          field: "format_image",
          sortable: false,
        },
        {
          label: "Asset Info",
          field: "format_info",
          sortable: false,
        },
        
        {
          label: "Action",
          field: "action",
          sortable: false,
        },
      ],

      rows: [],
      params: [],
      pageLength: 10,
      isAssetFormSubmitLoading: false,
      serverParams: {
        columnFilters: {},
        sort: [
          // { field: "id", type: "desc" },
          // { field: "name", type: "desc" },
          { field: "created_at", type: "desc" },
        ],
        page: 1,
        perPage: 10,
      },
      isFullscreen: false,
    };
  },
  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
      authUser: "userModule/getUser",
    }),

    statusVariant() {
      const statusColor = {
        true: "light-success",
        false: "light-danger",
      };

      return (status) => statusColor[status];
    },
  },

  async created() {
    try {
      this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }
  },

  methods: {
    formatAssetType(value) {
      const foundItem = this.assetTypeConstant.find(
        (item) => item.value === value
      );

      return foundItem.name;
    },
    formatDateTime(value) {
      if (value) {
        return this.$moment(value).format("MMM Do YY, h:mm: a");
      }
    },
    // for edit
    async getPreviousAttributeValues() {
      if (this.assetCategoryId) {
        const [editAttributes] = await Promise.all([
          this.getSingleAssetItems(),
        ]);

        this.editAttributeValueOptions =
          (editAttributes?.data?.data?.assetAttributeValues?.data).map(
            (item) => {
              let name = item.attribute_name;

              this.editAttributeValue.push(item.value);
              this.assetAttribute.push(item.attribute_id);

              return {
                name,
                value: item.value,
              };
            }
          );
      }
    },

    openAttributeOption() {
      this.openAttributeCheckbox = !this.openAttributeCheckbox;
    },

    formatLogDescription(value) {
      let description = "";

      if (value?.event == "updated" || value?.event == "created")
        description = value?.properties?.attributes?.description;

      return description;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.params = (params || []).map((item) => {
        let field = item.field;

        if (item.field == "format_info") {
          field = "title";
        }

        if (item.field == "format_email") {
          field = "email";
        }

        return {
          field: field,
          type: item.type,
        };
      });

      this.updateParams({
        sort: this.params,
      });
      this.loadItems();
    },

    onShowPage(id) {
      this.$router.push({
        name: "my-assets-details",
        params: { id },
      });
    },
    getPageUrl(id) {
      return this.$router.resolve({ name: "my-assets-details", params: { id } }).href;
    },
    async showDescriptionHistory(id) {
      const assetAcitivityLog = await this.getAssetAcitivityLog(id);

      this.assetAcitivityLog = [];
      this.assetAcitivityLog = assetAcitivityLog?.data?.data;

      // this.formatLogDescription(this.assetAcitivityLog);
      this.$bvModal.show("asset-description-log-modal");
    },


    async getAssetItems(params) {
      return await this.$api.get("api/get-my-asset", {
        params: {
          show: params.show,
          page: params.page,
          sort: params.sort,
          user_id: this.authUser.id,
        },
      });
    },

    async getAttributeItems() {
      return await this.$api.get(
        `api/asset-categories/${this.assetCategoryId}?include=attributes`
      );
    },

    async getSingleAssetItems() {
      const id = this.assetId;
      return await this.$api.get(
        `api/assets/${id}?include=assetAttributeValues`
      );
    },

    //Export Asset File
    async exportAsset() {
      try {
        const { data } = await this.$api.post(`/api/asset-exports`);
        window.location.href = data.data;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },
    async getAssetAcitivityLog(id) {
      const assetId = id;
      return await this.$api.get(`api/assets/${assetId}/activity-log`);
    },
    async loadItems() {
      try {
        const [assets] =
          await Promise.all([
            this.getAssetItems({
              show: this.serverParams.perPage,
              page: this.serverParams.page,
              sort: this.serverParams.sort,
            })
          ]);

        // assets Response
        const data = assets?.data?.data;
        this.rows = data;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },

    onSearch() {
      if (this.delayTimer) {
        clearTimeout(this.delayTimer);
        this.delayTimer = null;
      }

      this.delayTimer = setTimeout(() => {
        this.loadItems();
      }, 1000);
    },

    async assetFiltering() {
      this.loadItems();
    },

    async assetFilteringWithAttributeId(id, index) {
      this.loadItems();
    },

  },
};
</script>

<style lang="scss">
.asset-table {
  font-size: 13px !important;
  min-height: 137px !important;
  white-space: nowrap !important;
  tr,
  th,
  td {
    vertical-align: left !important;
    text-align: left !important;
  }
}
.description-para p {
  margin-bottom: 0rem !important;
  font-size: 13px !important;
}
.custom-font {
  font-size: 13px !important;
}
.custom-asset-image {
  height: 125px !important;
  width: 135px !important;
}
.btn-adjust {
  width: 100%;
}
.scrollable-checkbox-group {
  max-height: 200px;
  overflow-y: auto;
}
.required-label label::after {
  content: " *";
  color: red;
}
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/apps/calendar.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

</style>
